import React from 'react';
import { AlignLeft, Gauge, ListChecks } from 'lucide-react';
import Modal from '../../common/Modal';
import { useLanguage } from '../../../assets/js/LanguageContext';
import '../../../assets/styles/TemplateBuilder.css';

const TYPES = [
  { key: 'open', icon: AlignLeft, tone: '#7C3AED', labelKey: 'question_type_open', descKey: 'qtype_open_desc' },
  { key: 'closed', icon: ListChecks, tone: '#2563EB', labelKey: 'question_type_closed', descKey: 'qtype_closed_desc' },
  { key: 'rating', icon: Gauge, tone: '#0D9488', labelKey: 'dash_question_type_rating', descKey: 'qtype_rating_desc' }
];

const QuestionTypeSelectorModal = ({ open, onSelect, onClose }) => {
  const { t } = useLanguage();

  return (
    <Modal
      open={open}
      onOpenChange={(next) => { if (!next) onClose(); }}
      variant="edit"
      title={t('question_choose_type')}
      description={t('qtype_lead')}
      cancelText={t('common_cancel')}
      onCancel={onClose}
      size="md"
      className="tp-qtype-modal"
    >
      <ul className="tp-qtype">
        {TYPES.map(({ key, icon: Icon, tone, labelKey, descKey }) => (
          <li key={key}>
            <button
              type="button"
              className="tp-qtype__option"
              style={{ '--qtype-tone': tone }}
              onClick={() => onSelect(key)}
            >
              <span className="tp-qtype__icon" aria-hidden="true">
                <Icon size={20} strokeWidth={1.9} />
              </span>
              <span className="tp-qtype__body">
                <span className="tp-qtype__label">{t(labelKey)}</span>
                <span className="tp-qtype__desc">{t(descKey)}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default QuestionTypeSelectorModal;
